import { type IDropdownItem } from 'shared/ui'

export const mentionReplacer = (item: IDropdownItem) => {
  const template = typeof item.id === 'number' ? `{tag:user:${item.id}}` : '{tag:inbox}'

  return `<span data-readonly contentEditable="false" data-template="${template}" class='mentions-wrap'>${item.label}</span>`
}
